export default "/images/vendor/flag-icons/flags/1x1/fk.svg?e1087817d5fef6a7bd79a9c96a2117ab";